import React from "react";
import styled from "styled-components";

export default styled.div`
    
    max-height: 344px;
    overflow-y: scroll;
    border: 1px solid #979797;
    height: 355px;
    margin-bottom: 92px;
`;